import React from "react";
import { NavLink } from "react-router-dom";
import { Zap, ShieldCheck } from "lucide-react";
import { NAV_ITEMS } from "./navConfig";
import { useAuth } from "../../context/AuthContext";

export default function Sidebar() {
  const { user } = useAuth();
  return (
    <aside className="fixed left-0 top-0 z-40 hidden h-screen w-64 flex-col border-r border-white/8 bg-[#0c0c0e] lg:flex" data-testid="sidebar">
      <div className="flex items-center gap-2.5 px-6 py-6">
        <span className="grid h-8 w-8 place-items-center rounded-md bg-gradient-to-br from-[#f3f4f6] to-[#aeb3b9] text-black">
          <Zap size={16} />
        </span>
        <span className="font-head text-sm font-extrabold tracking-tight text-silver">SANJAY LIMITLESS</span>
      </div>

      <div className="px-4 pb-2 pt-2">
        <p className="px-3 font-mono text-[10px] uppercase tracking-widest text-neutral-600">Workspace</p>
      </div>

      <nav className="flex flex-1 flex-col gap-1 px-4">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`side-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) =>
              `group relative flex items-center gap-3 rounded-xl px-3 py-2.5 font-mono text-[12px] uppercase tracking-wide transition-colors ${
                isActive ? "bg-white/[0.05] text-white" : "text-neutral-500 hover:bg-white/[0.02] hover:text-neutral-200"
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute left-0 top-1/2 h-5 w-[2px] -translate-y-1/2 rounded-full bg-silver" />}
                <item.icon size={17} />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        {user?.role === "admin" && (
          <NavLink to="/admin" data-testid="side-nav-admin"
            className={({ isActive }) => `group relative mt-1 flex items-center gap-3 rounded-xl px-3 py-2.5 font-mono text-[12px] uppercase tracking-wide transition-colors ${isActive ? "bg-white/[0.05] text-white" : "text-neutral-500 hover:bg-white/[0.02] hover:text-neutral-200"}`}>
            {({ isActive }) => (<>{isActive && <span className="absolute left-0 top-1/2 h-5 w-[2px] -translate-y-1/2 rounded-full bg-silver" />}<ShieldCheck size={17} /><span>Admin</span></>)}
          </NavLink>
        )}
      </nav>

      <div className="px-6 py-6">
        <p className="font-mono text-[9px] uppercase leading-relaxed tracking-widest text-neutral-700">
          Trading involves risk. Past performance does not guarantee future results.
        </p>
      </div>
    </aside>
  );
}
